export function objectToFormData(object: Object): string {
  const urlParams = new URLSearchParams();
  Object.keys(object).forEach((key: string) => {
    urlParams.append(key, object[key]);
  });
  return urlParams.toString();
}
